import React from 'react';
import classnames from 'classnames';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import UserLink from '@wix/da-shared-react/pkg/User/Link/UserLink';
import { OverlayContextProvider } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import type { BIEventPayload } from '@wix/da-bi/pkg/types';
import DeviantsBar from '../../../../DeviantsBar';
import SingleDeviantEmptyResult from '../../../../EmptyResult/SingleDeviant';
import BasePageLayout from '../../../_partials/BasePageLayout';
import DefaultPageContent from '../../../_partials/DefaultPageContent';
import WatchButton from '../../../../WatchButton';
import WatchedUserMenu from '../../../../WatchedUserMenu';
import DeviantsSearchButton from '../../../../DeviantsSearchButton';

import s from './MobileArtistWatchPage.scss';

export interface Props {
  feedType?: string;
  thisUser: PapiUser;
  isEmpty?: boolean;
  showRemoveAll?: boolean;
  removeAll: (biData: BIEventPayload) => void;
  removeDeviation: (deviation: PapiDeviation, offset: number) => void;
}

const MobileArtistWatchPage: React.FC<Props> = ({
  feedType,
  thisUser,
  isEmpty,
  showRemoveAll,
  removeAll,
  removeDeviation,
}) => {
  const isDyw3 = useFlag('dyw3');
  return (
    <BasePageLayout
      customHeader={
        <>
          <DeviantsBar />
          <div className={s['profile-bar']}>
            <UserLink user={thisUser} className={s['username']} />
            <WatchButton user={thisUser} className={s['watch-button']} />
            {(!isDyw3 || showRemoveAll) && (
              <WatchedUserMenu
                user={thisUser}
                removeAll={removeAll}
                className={s['user-menu']}
              />
            )}
          </div>
        </>
      }
      headerRightSideContent={
        <DeviantsSearchButton selectedUserId={thisUser.userId} />
      }
      headerIsStickyOnScrollUp
      contentClassName={classnames(isEmpty && s['content-empty'])}
    >
      {isEmpty ? (
        <SingleDeviantEmptyResult feedType={feedType} />
      ) : (
        <OverlayContextProvider
          value={{
            showPermanentEngagementIcon: true,
          }}
        >
          <DefaultPageContent onRemove={isDyw3 ? removeDeviation : undefined} />
        </OverlayContextProvider>
      )}
    </BasePageLayout>
  );
};
MobileArtistWatchPage.displayName = 'MobileArtistWatchPage';

export default MobileArtistWatchPage;
